<template>
	<div class="v-payment-systems types">
		<button v-if="isMob && showCryptoTypes" class="types__btn btn btn--sm" type="button" @click="showCryptoTypes = false">Вернуться назад</button>
		<div class="types__row">
			<div class="types__item" v-for="type in showCryptoTypes ? cryptoItems : defaultItems" :key="type.id">
				<div class="types__item-logo" @click="setType(type)" :class="[selectedType && selectedType.id === type.id ? ['active'] : '']">
					<span v-if="type.caption" class="types__item-caption">{{ type.caption }}</span>
					<img :src="type.icon" class="types__item-icon">
				</div>
				<div v-if="showCryptoTypes" class="types__item-text">{{ type.title }}</div>
			</div>
			<div class="types__item" v-if="isMob && !showCryptoTypes && cryptoItems?.length">
				<div class="types__item-logo" @click="showCryptoTypes = true">
					<img :src="cryptoImg" class="types__item-icon types__item-icon--lg">
				</div>
			</div>
		</div>

		<div class="types__row" v-if="!isMob">
			<div class="types__item" v-for="type in cryptoItems">
				<div :key="type.id" class="types__item-logo" @click="setType(type)" :class="[selectedType && selectedType.id === type.id ? ['active'] : '']">
					<img :src="type.icon" class="types__item-icon">
				</div>
				<div class="types__item-text">{{ type.title }}</div>
			</div>
		</div>
	</div>

</template>

<script>

import breakpointsMixin from '../../mixins/breakpoints-mixin.vue';

export default {
	emits: [
		'set-type'
	],

	mixins: [
		breakpointsMixin
	],

	props: {
		items: {
			type: Array,
			default: null
		},

		selectedType: {
			type: [Object, Boolean],
			default: null
		}
	},

	data() {
		return {
			showCryptoTypes: false,
			cryptoImg: 'images/cryptos.svg'
		}
	},

	computed: {
		defaultItems() {
			return this.items.filter(type => type.group_code !== 'crypto');
		},

		cryptoItems() {
			return this.items.filter(type => type.group_code === 'crypto');
		}
	},

	watch: {
		isTablet(state) {
			if (!state) this.showCryptoTypes = false;
			if (state) this.setDefaultType();
		},

		showCryptoTypes() {
			this.setDefaultType()
		}
	},

	methods: {
		setType(type) {
			this.$emit('set-type', type)
		},

		setDefaultType() {
			if (this.isTablet) {
				this.$emit('set-type', this.showCryptoTypes ? null : (this.defaultItems?.find(item => item.code === 'card_p2p' ) || this.defaultItems[0]))
			}
		}
	}
}

</script>
